import moment from 'moment'

export const  tipoInversion = (tipo:string)=>{
    let e = ''
    if(tipo==='mensual') e = 'MENSUAL'
    if(tipo==='finalizando') e = 'AL FINALIZAR EL CONTRATO'
      return e
  }



export const  labelPrivilegio = (rol:string)=>{
    let e = ''

    if(rol==='ROLE_ADMIN') e = 'ADMINISTRADOR'
    if(rol==='ROLE_PAGOS') e = 'PAGOS'
    if(rol==='ROLE_GERENTE') e = 'GERENTE'
    if(rol==='ROLE_DEPARTAMENTO') e = 'DEPARTAMENTO'
    if(rol==='ROLE_ASESOR') e = 'ASESOR'
    if(rol==='ROLE_ASISTENTE') e = 'ASISTENTE'
    if(rol==='ROLE_ASEGURADORA') e = 'ASEGURADOR'
    if(rol==='ROLE_VERIFICADOR_TELEFONICO') e = 'VERIFICADOR TELEFÓNICO'
    if(rol==='ROLE_GERENTE_JR') e = 'GERENTE JR'
    if(rol==='ROLE_GERENTE_CONSOLIDADO') e = 'GERENTE'
    if(rol==='ROLE_ADMIN_MESA') e = 'ADMIN MESA'
    if(rol==='ROLE_RECURSOS_HUMANOS') e = 'RECURSOS HUMANOS'
    if(rol==='ROLE_ASESOR_BASE') e = 'ASESOR BASE'
    if(rol==='ROLE_DIRECTOR_COMERCIAL') e = 'DIRECTOR COMERCIAL'
    if(rol==='ROLE_CONTABILIDAD') e = 'CONTABILIDAD'
    if(rol==='ROLE_SUPERVISOR') e = 'SUPERVISOR DE ASESORES'


    if(rol==='ROLE_DIRECTOR_EXPANSION') e = 'DIRECTOR EXPANSIÓN'
    if(rol==='ROLE_DIRECTOR_GENERAL') e = 'DIRECTOR GENERAL'

    if(rol==='ROLE_FINANZAS_CAPTURAS') e = 'CONTABILIDAD CAPTURA'


      return e

  }

export const  labelTipoReporteAuditoria = (tipo_movimiento:string)=>{
    let e = ''

if(tipo_movimiento==='BRINDA_ACCESO') e = 'BRINDA ACCESO'
if(tipo_movimiento==='BLOQUEO_ACCESO') e = 'BLOQUEO ACCESO'
if(tipo_movimiento==='DEGRADACION_ASESOR_GERENTE') e = 'DEGRADACIÓN DE GERENTE-ASESOR'
if(tipo_movimiento==='PROMOCION_GERENTE_ASESOR') e = 'PROMOCIÓN ASESOR-GERENTE'
if(tipo_movimiento==='CAMBIO_USERNAME') e = 'CAMBIO DE NOMBRE DE USUARIO'
if(tipo_movimiento==='CAMBIO_INFORMACION_PERSONAL') e = 'CAMBIO DE INFORMACIÓN PERSONAL'
if(tipo_movimiento==='ACTUALIZA_FECHA_INGRESO') e = 'CAMBIO DE FECHA DE INGRESO'
if(tipo_movimiento==='CAMBIO_PASSWORD') e = 'CAMBIO DE CONTRASEÑA'
if(tipo_movimiento==='CAMBIO_ROL') e = 'CAMBIO_ROL'
if(tipo_movimiento==='MOVIMIENTO_ADMINISTRATIVO') e = 'MOVIMIENTO ADMINISTRATIVO'
if(tipo_movimiento==='CREACION_CUENTA_ACCESO') e = 'CREACIÓN DE CUENTA'
if(tipo_movimiento==='DIRECCION_COMERCIAL_RESPONSABILIDADES') e = 'CAMBIO DE RESPONSABILIDAD DE DIRECTOR COMERCIAL'
if(tipo_movimiento==='ASIGNACION_GERENTE_ASESOR') e = 'ASIGNAR GERENTE'



      return e

  }


export const formatToTwoDecimals=(num:number)=> {
    return num.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export const formatearNumeroConComas =(num:any)=>{
    return num.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}


export const descargarArchivo = (url:string) => {
fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/pdf',
    },
  })
  .then((response) => response.blob())
  .then((blob) => {
    // Create blob link to download
    const url : any = window.URL.createObjectURL(
      new Blob([blob]),
    );
    const link : any = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `FileName.pdf`,
    );

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
  });
}




export const obtenerInicioFinMesActual = () => {
  const fechaActual = new Date();
  const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
  const ultimoDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);

  return {
    inicioMes: primerDiaMes,
    finMes: ultimoDiaMes,
  };
}

export const  getStartAndEndDates=(dateString:any)=> {
    let date = dateString;

    // Fecha de inicio (primer día del mes)
    let startDate = new Date(date.getFullYear(), date.getMonth(), 1);

    // Fecha de fin (último día del mes)
    let endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    return {
        inicioMes: startDate,
        finMes: endDate
    };
}





export const obtenerInicioFinSemanaActual = () => {
  const fechaActual = new Date();
  const diaSemana = fechaActual.getDay(); // 0 (domingo) a 6 (sábado)

  // Restamos el número de días transcurridos desde el primer día de la semana (domingo) hasta la fecha actual
  const diasDesdePrimerDiaSemana = diaSemana - 0;

  // Obtenemos el primer día de la semana restando los días desde el primer día del mes
  const primerDiaSemana = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate() - diasDesdePrimerDiaSemana);

  // Obtenemos el último día de la semana sumando los días restantes hasta el último día de la semana (sábado)
  const ultimoDiaSemana = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate() + (6 - diasDesdePrimerDiaSemana));

  return {
    inicioSemana: primerDiaSemana,
    finSemana: ultimoDiaSemana,
  };
}




export const calcularTiempoTranscurrido = (fecha:any)=>{
  const fechaConsulta = moment();
  const fechaParametro = moment(fecha);

  // Caso 1: Mismo día
  if (fechaConsulta.isSame(fechaParametro, 'day')) {
    const horasTranscurridas = fechaConsulta.diff(fechaParametro, 'hours');
    const minutosTranscurridos = fechaConsulta.diff(fechaParametro, 'minutes') % 60;

    if (horasTranscurridas > 0) {
      return `Hace ${horasTranscurridas} horas y ${minutosTranscurridos} minutos`;
    } else if (minutosTranscurridos > 0) {
      return `Hace ${minutosTranscurridos} minutos`;
    } else {
      return 'Hace unos momentos';
    }
  }

  // Caso 2: Ayer
  if (fechaConsulta.isSame(fechaParametro.clone().add(1, 'day'), 'day')) {
    return 'Ayer';
  }

  // Caso 3: Más de 2 días
  if (fechaConsulta.diff(fechaParametro, 'months') >= 2) {
    return `Hace ${fechaConsulta.diff(fechaParametro, 'months')} meses`;
  }

  // Caso 4: Más de 12 meses + 1 día
  if (fechaConsulta.diff(fechaParametro, 'years') >= 1) {
    return `Hace ${fechaConsulta.diff(fechaParametro, 'years')} años`;
  }

  // Caso 5: Más de 2 meses pero menos de 12 meses
  const diasTranscurridos = fechaConsulta.diff(fechaParametro, 'days');
  return diasTranscurridos > 0 ? `Hace ${diasTranscurridos} días` : 'Hoy';
}






export const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
export const REG_RFC = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/
export const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u
export const REG_SS = /^(\d{2})(\d{2})(\d{2})\d{5}$/


export const curp2date = (curp:any) => {
  var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ );
  //miFecha = new Date(año,mes,dia) 
  var anyo = parseInt(m[1],10)+1900;
  if( anyo < 1950 ) anyo += 100;
  var mes = parseInt(m[2], 10)-1;
  var dia = parseInt(m[3], 10);
  return moment(new Date( anyo, mes, dia )).format('YYYY-MM-DD');
}






